import HyperLink from '@acorn-portal/shared/src/components/hyperlink';
import { IFooterDetail } from '@acorn-portal/shared/src/components/footer';
import { MOTORCADE_TERMS_OF_BUSINESS } from '@acorn-portal/shared/src/utils/constants';
import { ButtonBase, Typography } from '@mui/material';

export const FooterDetails: IFooterDetail[] = [
	{
		title: 'Terms of Business',
		content: (
			<Typography
				component='a'
				href={MOTORCADE_TERMS_OF_BUSINESS}
				target='_blank'
				rel='noreferrer'
				sx={{ color: 'white' }}
			>
				Our Terms of Business
			</Typography>
		),
	},
	{
		title: 'Registered Office Details',
		content: (
			<Typography>
				Motorcade Insurance is a trading name for Acorn Insurance and Financial Services Ltd, which is authorised and
				regulated by the Financial Conduct Authority (FCA)
				<br />
				Registration Number 311873. Registered Address 98 Liverpool Road, Formby, Liverpool, Merseyside, L37 6BS
			</Typography>
		),
	},
	{
		title: 'Contact Us',
		content: (
			<Typography>
				To get in touch, please click{' '}
				<Typography component='a' href='https://motorcade.co.uk/contact-us' target='_blank' sx={{ color: 'white' }}>
					here
				</Typography>
			</Typography>
		),
	},
	{
		title: 'Privacy Notice',
		content: (
			<Typography
				component='a'
				href='https://www.acorninsure.co.uk/docs/Privacy-Policy.pdf'
				target='_blank'
				sx={{ color: 'white' }}
			>
				Our Privacy Notice.
			</Typography>
		),
	},
];

const Copy = {
	questionAccuracy: (
		<>
			It&apos;s important that you answer all questions fully and accurately. If you deliberately or carelessly make a
			misrepresentation, your insurance cover could be invalidated and any claims rejected or not paid in full.
		</>
	),
	keepingInformed: (
		<>
			Acorn Insurance and affiliated companies in our Group would like to occasionally contact you to tell you about new
			products, special offers and promotions, so you don&apos;t miss out. Further information can be found in our{' '}
			<HyperLink
				href='https://motorcade.co.uk/wp-content/uploads/2021/02/Privacy-Notice-Acorn-Insurance-and-Financial-Services-Limited-February-2021.pdf'
				target='_blank'
				rel='noreferrer'
			>
				Privacy Notice
			</HyperLink>
			. If you&apos;d prefer not to hear from us, please tick the relevant boxes below.
		</>
	),
	declinedPage: (
		<>
			Thank you for requesting a quote with Motorcade Insurance, unfortunately we are unable to progress with your
			insurance application at this time
		</>
	),
	errorPage: (
		<>
			You are seeing this page because an error has occurred, please return to the{' '}
			<ButtonBase
				sx={(theme) => ({
					fontSize: 'inherit',
					verticalAlign: 'unset',
					padding: 0,
					color: theme.palette.primary.main,
					textDecoration: 'underline',
					'&:hover': {
						color: theme.palette.primary.light,
					},
					'&:visited': {
						color: theme.palette.primary.main,
						'&:hover': {
							color: theme.palette.primary.light,
						},
					},
				})}
			>
				home page
			</ButtonBase>
			and try again, or contact us if the problem persists.
		</>
	),
};

export default Copy;
